import { useTranslation } from 'react-i18next';
import { Text } from '../../../../foundations';
import styles from './DocumentationRequired.module.css';
import { MandatoryDocument, OthersDocuments, VisaDocuments } from './components';
import { useDocumentationRequired } from '../../hooks/UseDocumentationRequired';
import { DocumentObject } from '../../ApisForm.model';
import { DocumentationRequiredProps } from './DocumentationRequired.model';
import { useEffect, useState } from 'react';
import { ErrorBoundaryProvider } from '../../../../../providers/ErrorBoundaryProvider';

export const DocumentationRequired = ({ isInfant = false }: DocumentationRequiredProps) => {
	const { t } = useTranslation(['documentation-required', 'common']);
	const {
		id,
		isOptional,
		minDate,
		maxDate,
		//destination,
		listOptions,
		documentationRequired,
		existErrorVisa,
		getOptionsOptionalDocuments
	} = useDocumentationRequired({ isInfant });
	const { visa, others, defaultVisa } = getOptionsOptionalDocuments(listOptions);
	const [showVisa, setShowVisa] = useState(visa ? true : false);
	const [dataVisa, setDataVisa] = useState(visa);
	const args = { isOptional, minDate, maxDate, isInfant };

	useEffect(() => {
		if (!dataVisa) {
			setDataVisa(defaultVisa);
		}
	}, [dataVisa]);

	useEffect(() => {
		if (existErrorVisa && !showVisa) {
			setShowVisa(existErrorVisa);
		}
	}, [existErrorVisa]);

	return (
		<ErrorBoundaryProvider>
			<div className={styles.box_container} id={`documentation-required${String(id)}`}>
				<Text as="h4" font="iberia-headline" className={styles.box_title}>
					{/* {t('TITLE', { destination })} */}
					{t('TITLE_SECTION')}
				</Text>
				<MandatoryDocument {...args} />

				{showVisa && <VisaDocuments options={dataVisa} {...args} />}

				{others && (
					<OthersDocuments options={others} config={documentationRequired?.other as DocumentObject[]} {...args} />
				)}
			</div>
		</ErrorBoundaryProvider>
	);
};
DocumentationRequired.displayName = 'DocumentationRequired';
